import { AsyncEvent } from 'ts-events';
import './components';
import config from './config';
import './controllers';
import './directives';
import './filters';
import { hasValue } from './helpers';
import './partials/messenger';
import './partials/welcome';
import './services';
import './threema/container';
AsyncEvent.setScheduler(function (callback) {
    setTimeout(callback, 0);
});
angular.module('3ema', [
    'ngAnimate',
    'ngSanitize',
    'ngAria',
    'ui.router',
    'angular-inview',
    'monospaced.qrcode',
    'luegg.directives',
    'pascalprecht.translate',
    'ngMaterial',
    '3ema.filters',
    '3ema.components',
    '3ema.directives',
    '3ema.container',
    '3ema.services',
    '3ema.controllers',
    '3ema.welcome',
    '3ema.messenger',
])
    .value('VERSION', config.VERSION)
    .value('PROTOCOL_VERSION', 2)
    .constant('CONFIG', config)
    .constant('CACHE_BUST', `v=${config.VERSION}`)
    .constant('BROWSER_MIN_VERSIONS', {
    FF: 60,
    FF_IOS: 8,
    CHROME: 65,
    OPERA: 52,
    SAFARI: 11,
    EDGE: 79,
})
    .config(['$urlRouterProvider', ($urlRouterProvider) => {
        $urlRouterProvider.otherwise('/welcome');
    }])
    .config(['$translateProvider', ($translateProvider) => {
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.useMessageFormatInterpolation();
        $translateProvider
            .useStaticFilesLoader({
            prefix: 'i18n/',
            suffix: '.json',
        })
            .uniformLanguageTag('java')
            .registerAvailableLanguageKeys(['be', 'bg', 'cs', 'de', 'en', 'eo', 'es', 'fr', 'hu', 'it', 'ja', 'ko', 'nl', 'pl', 'ro', 'ru', 'sk', 'tr', 'uk', 'zh_TW', 'zh'], {
            'be_*': 'be',
            'bg_*': 'bg',
            'cs_*': 'cs',
            'de_*': 'de',
            'en_*': 'en',
            'eo_*': 'eo',
            'es_*': 'es',
            'fr_*': 'fr',
            'hu_*': 'hu',
            'it_*': 'it',
            'ja_*': 'ja',
            'ko_*': 'ko',
            'nl_*': 'nl',
            'pl_*': 'pl',
            'ro_*': 'ro',
            'ru_*': 'ru',
            'sk_*': 'sk',
            'tr_*': 'tr',
            'uk_*': 'uk',
            'zh_HANT': 'zh_TW',
            'zh_CHT': 'zh_TW',
            'zh_HK': 'zh_TW',
            'zh_MO': 'zh_TW',
            'zh_HANS': 'zh_TW',
            'zh_CHS': 'zh_TW',
            'zh_SG': 'zh',
            'zh_CN': 'zh',
            'zh_*': 'zh',
        })
            .determinePreferredLanguage()
            .fallbackLanguage('en');
    }])
    .config(['$mdThemingProvider', ($mdThemingProvider) => {
        $mdThemingProvider.definePalette('threema', {
            50: 'f2faf5',
            100: 'e6f6eb',
            200: 'cdedd9',
            300: 'b4e4c5',
            400: '9bdbb2',
            500: '82d29f',
            600: '69ca8c',
            700: '50c078',
            800: '37b865',
            900: '1eae52',
            A100: '05a63f',
            A200: '048432',
            A400: '03732b',
            A700: '036325',
            contrastDefaultColor: 'light',
            contrastDarkColors: ['50', '100', '200', '300', '400', '500', '600'],
        });
        $mdThemingProvider.definePalette('threemawork', {
            50: '#f2f9ff',
            100: 'e5f4ff',
            200: 'cceaff',
            300: 'b2dfff',
            400: '99d5ff',
            500: '7fcaff',
            600: '66c0ff',
            700: '4cb5ff',
            800: '33abff',
            900: '19a0ff',
            A100: '0096ff',
            A200: '0086e5',
            A400: '0068b2',
            A700: '004a7f',
            contrastDefaultColor: 'light',
            contrastDarkColors: ['50', '100', '200', '300', '400', '500', '600'],
        });
        $mdThemingProvider.theme('threema')
            .primaryPalette('grey', { default: '800' })
            .accentPalette('threema', { default: 'A100' });
        $mdThemingProvider.theme('threemawork')
            .primaryPalette('grey', { default: '800' })
            .accentPalette('threemawork', { default: 'A100' });
        $mdThemingProvider.alwaysWatchTheme(true);
    }])
    .config(['$compileProvider', ($compileProvider) => {
    }])
    .config(['$httpProvider', ($httpProvider) => {
        $httpProvider.interceptors.push(['CACHE_BUST', (CACHE_BUST) => {
                return {
                    request: (conf) => {
                        if (conf.url.indexOf('partials/') !== -1 ||
                            conf.url.indexOf('directives/') !== -1 ||
                            conf.url.indexOf('components/') !== -1 ||
                            conf.url.indexOf('i18n/') !== -1) {
                            const separator = conf.url.indexOf('?') === -1 ? '?' : '&';
                            conf.url = conf.url + separator + CACHE_BUST;
                        }
                        return conf;
                    },
                };
            }]);
    }])
    .factory('$exceptionHandler', ['LogService', function (logService) {
        const logger = logService.getLogger('UncaughtException');
        return function myExceptionHandler(e, cause) {
            if (!hasValue(e)) {
                logger.error(`Unhandled exception (ng): ${e}`);
                return;
            }
            const data = [];
            data.push('Unhandled exception (ng):');
            if (e.message && e.name) {
                data.push(e.message.includes(e.name) ? `${e.message}\n` : `${e.name}: ${e.message}\n`);
            }
            data.push(e.stack ? e.stack : e);
            if (cause) {
                data.push('\nCaused by:\n');
                data.push(cause.stack ? cause.stack : cause);
            }
            logger.error(...data);
        };
    }]);
